export default function (value, decimals) {
  let val = (value / 1).toFixed(decimals)
  return val.toString()
}



// WEBPACK FOOTER //
// ./src/filters/currency.js